module.exports = __webpack_public_path__ + "img/logo3.cf5fbca1.png";